export const tableConfig = [
  {
    name: "namaCabang",
    label: "Cabang",
      setCellProps: () => ({
        style: { width: "150px", minWidth: "100px" },
      }),
  },
  {
    name: "totalNew",
    label: "New Prospek",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "totalROH23",
    label: "RO H23",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "totalNonFollowup",
    label: "NON FU",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "rateNonFollowupNew",
    label: "Rate NON FU NEW (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "rateNonFollowupROH23",
    label: "Rate NON FU RO H23 (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "totalOngoing",
    label: "ONGOING",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "rateOngoingNew",
    label: "Rate ONGOING NEW (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "rateOngoingROH23",
    label: "Rate ONGOING RO H23 (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "totalDeal",
    label: "DEAL",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "rateDealNew",
    label: "Rate DEAL New (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "rateDealROH23",
    label: "Rate DEAL RO H23 (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "totalDrop",
    label: "DROP",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "rateDropNew",
    label: "Rate DROP NEW (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
  {
    name: "rateDropROH23",
    label: "Rate DROP RO H23 (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px" },
      }),
    },
  },
];
